<template>
    <div class="MAM_searchResult">
        <el-dialog :visible="infoIsShow" @close="handleClose" :close-on-click-modal="false" >
            <el-card class="box-card" shadow="hover">
                <div class="purseTitle">
                    <div>终端交易明细</div>
                </div>
                <el-table
                        :data="transferList.list"
                        size="mini"
                        height="200"
                        border
                        style="width: 100%"
                        v-loading="loading"
                >
                    <!-- id -->
                    <el-table-column
                            header-align="center"
                            align="center"
                            type="index"
                            label="序号"
                            min-width="80"
                    ></el-table-column>
                    <!-- SN -->
                    <el-table-column
                            header-align="center"
                            align="center"
                            prop="terminal_sn"
                            label="SN"
                            min-width="120"
                    ></el-table-column>
                    <!-- 商户编号 -->
                    <el-table-column
                            header-align="center"
                            align="center"
                            prop="merchant_number"
                            label="商户编号"
                            min-width="120"
                            v-if="level == 0"
                    ></el-table-column>

                    <!-- 交易金额 -->
                    <el-table-column
                            header-align="center"
                            align="center"
                            prop="transaction_money"
                            label="交易金额"
                            min-width="120"
                    ></el-table-column>

                    <!--&lt;!&ndash; 商户名称 &ndash;&gt;
                    <el-table-column
                            header-align="center"
                            align="center"
                            prop="merchant_name"
                            label="商户名称"
                            min-width="120"
                    ></el-table-column>-->
                </el-table>
            </el-card>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: "MAM_searchResult",
    props: {
        infoIsShow: {
            type: Boolean,
            default: false
        },
        detail: {
            type: Object
        }
    },
    data() {
        return {
            level:sessionStorage.getItem('level'),
            transctionInfoTable: [], //表格
            viewData: {},
            page: {
                currentPage: 1, //当前页码
                pageSize: 10, //条数
                total: 0  //总数
            },
            id: null,
            loading: true,
            transferList: {
                list: [],
            },
        }


    },
    mounted() {
        this.id = this.detail.id;
        this.getData();
    },
    methods: {
        handleClose() {
            this.$emit('infoClose')
        },
        getData() {
            this.$api.post("terminal_equipment/get_terminal_equipment_transaction", { id: this.detail.id }, res => {
                let data = res.data;
                //this.page.total = data.count; //总数
                this.transferList.list = res.data.list;
                let { count,count1,count2,count3,count4,count5, list } = data;
                this.tableTitle = {count,count1,count2,count3,count4,count5};
                //渲染结束后取消加载
                this.loading = false;
            })
        }
    }
};
</script>

<style scoped lang="scss">
.MAM_searchResult {
    .purseTitle {
        font-size: 12px;
        margin: 10px 0;
        color: #909399;
        :nth-child(1) {
            font-weight: 700;
            color: #7f7f7f;
            padding-left: 10px;
            border-left: 4px solid #909399;
        }
    }
    .rowTitle {
        color: #909399;
        font-size: 12px;
        .el-col {
            margin: 5px 0;
        }
        .labels {
            font-weight: 700;
        }
    }
}
</style>